export enum ChangePasswordSteps {
  InvalidToken = 'INVALID_TOKEN',
  Form = 'FORM',
  Success = 'SUCCESS',
}
